import { type FC } from "react";
import { Menu } from "lucide-react";

import { Button } from "@/shared/components/ui/button";
import { useSidebar } from "@/shared/components/ui/sidebar";
import logoFull from "@/shared/assets/logo/logo-full.svg";

export const ConditionalSidebarTrigger: FC = () => {
  try {
    useSidebar();
    return <MobileMenuButton />;
  } catch {
    return null;
  }
};

const MobileMenuButton: FC = () => {
  const { toggleSidebar } = useSidebar();

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={toggleSidebar}
      className="text-primary border-primary"
      aria-label="Open menu"
    >
      <Menu className="h-4 w-4" />
    </Button>
  );
};

export const MobileNavHeader: FC = () => {
  return (
    <>
      <div className="flex-shrink-0 lg:hidden">
        <ConditionalSidebarTrigger />
      </div>
      <div className="flex-grow flex justify-center lg:hidden">
        <img src={logoFull} alt="Elayne" className="h-[27px]" />
      </div>
    </>
  );
};
